import styled from '@emotion/styled'

export const ProfitAndLossContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  padding-bottom: var(--lumen-padding-24);
  position: relative;
`
